import PageForgotPassword from './components/ForgotPassword';

export default PageForgotPassword;